export default function (possibleArray) {
    if (possibleArray === undefined) {
        return [];
    }
    if (!Array.isArray(possibleArray)) {
        possibleArray = [possibleArray];
    }
    return possibleArray;
}



// WEBPACK FOOTER //
// ./src/javascripts/app/lib/common/arrayWrap.js